import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";
import "leaflet/dist/leaflet.css";

function MapView() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [temple, setTemple] = useState(null);
  const [userLocation, setUserLocation] = useState(null);

  const routingRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    fetch(`https://api.washim.org/api/temples/${id}`)
      .then(res => res.json())
      .then(data => setTemple(data));
  }, [id]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation([
          position.coords.latitude,
          position.coords.longitude
        ]);
      },
      () => {
        console.log("Location permission denied");
      }
    );
  }, []);

  useEffect(() => {
    if (!mapRef.current || !userLocation || !temple) return;

    const lat = Number(temple.latitude);
    const lng = Number(temple.longitude);

    if (!lat || !lng) return;

    const templeLocation = [lat, lng];

    // Remove old route if exists
    if (routingRef.current) {
      mapRef.current.removeControl(routingRef.current);
      routingRef.current = null;
    }

    routingRef.current = L.Routing.control({
      waypoints: [
        L.latLng(userLocation[0], userLocation[1]),
        L.latLng(templeLocation[0], templeLocation[1])
      ],
      routeWhileDragging: false,
      addWaypoints: false,
      draggableWaypoints: false,
      show: false,
      createMarker: () => null
    }).addTo(mapRef.current);

  }, [userLocation, temple]);

  if (!temple) return <h3 className="text-center mt-5">Loading Map...</h3>;

  const lat = Number(temple.latitude);
  const lng = Number(temple.longitude);

  if (!lat || !lng) {
    return (
      <div className="container mt-5 text-center">
        <h4>Location coordinates not available.</h4>
        <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
          ⬅ Back
        </button>
      </div>
    );
  }

  const templeLocation = [lat, lng];

  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl:
      "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
    iconUrl:
      "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    shadowUrl:
      "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png"
  });

  return (
    <div className="container mt-4 mb-5">
      <h3 className="text-center mb-3">
        🗺 Directions to {temple.name}
      </h3>

      <div style={{ height: "500px", width: "100%" }}>
        <MapContainer
          center={templeLocation}
          zoom={13}
          style={{ height: "100%", width: "100%" }}
          whenCreated={(mapInstance) => {
            mapRef.current = mapInstance;
          }}
        >
          <TileLayer
            attribution="&copy; OpenStreetMap contributors"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          <Marker position={templeLocation}>
            <Popup>{temple.name}</Popup>
          </Marker>

          {userLocation && (
            <Marker position={userLocation}>
              <Popup>Your Location</Popup>
            </Marker>
          )}
        </MapContainer>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-secondary" onClick={() => navigate(-1)}>
          ⬅ Back
        </button>
      </div>
    </div>
  );
}

export default MapView;
